/**
 * Кнопка «Поделиться» из iOS: квадрат с открытым верхом и стрелкой вверх.
 * Своя разметка, потому что Tabler рисует «поделиться» как граф из точек —
 * в инструкции нужна именно иконка Safari.
 */

export function ShareGlyph({ size = 24 }: { readonly size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M8 11v7a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-7" />
      <path d="M14 17V4" />
      <path d="M10 8l4-4 4 4" />
    </svg>
  );
}
